/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { CreateCategoryInput } from './create-category-input';
import { CreateFileInput } from './create-file-input';
import { CreatePropertyInput } from './create-property-input';
import { AssetTypes, InvestmentClass, SaleInterestPayoutPeriod } from '../types/utils';
import { CreateCostCalculationPercentageInput } from './create-cost-calculation-percentage-input';

export class CreateSaleInput {
	assetType: AssetTypes = AssetTypes.LOAN

	baFinId: string = ''

	company: string = ''

	corePropertyRepresentations: Array<CreateCategoryInput> = []

	description: string = ''

	descriptionTitle: string = ''

	documents?: Array<CreateFileInput>

	endDate: Date = new Date()

	estimatedValueIncrease: number = 0

	fee: number = 0

	feeEnd: number = 0

	feeOngoing: number = 0

	firstPayoutOfInterest: Date = new Date()

	highlights: Array<string> = []

	images?: Array<CreateFileInput>

	interestPayoutPeriod: SaleInterestPayoutPeriod = SaleInterestPayoutPeriod.YEARLY

	interestRate: number = 0

	investmentClass: InvestmentClass = InvestmentClass.INVESTMENT_FUND

	maxPurchase?: number

	minPurchase: number = 0

	percentages: Array<CreateCostCalculationPercentageInput> = []

	platformAssetValue: number = 0

	predictedPerformance: number = 0

	properties?: Array<CreatePropertyInput>

	scoreCustomerGroup: number = 0

	scoreInvestmentClass: number = 0

	scoreWPServices: number = 0

	startDate: Date = new Date()

	subtitle: string = ''

	supertitle: string = ''

	title: string = ''

	totalAssetValue: number = 0
}

export const SaleCoreProperties = [
	'company',
	'endDate',
	'estimatedValueIncrease',
	'fee',
	'feeEnd',
	'feeOngoing',
	'firstPayoutOfInterest',
	'interestPayoutPeriod',
	'interestRate',
	'maxPurchase',
	'minPurchase',
	'platformAssetValue',
	'predictedPerformance',
	'startDate',
	'totalAssetValue',
]